import { render } from "./DeleteReportTheme.vue?vue&type=template&id=4b532c56"
import script from "./DeleteReportTheme.vue?vue&type=script&lang=js"
export * from "./DeleteReportTheme.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__